import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
  Autocomplete,
  Checkbox,
  FormControlLabel,
  Tooltip,
} from "@mui/material";

const MasterEntrySelectorModal = ({
  open,
  onClose,
  masterEntries,
  onSelect,
  preSelectedId,
  onLink,
}) => {
  const [selectedEntry, setSelectedEntry] = useState(null);
  const [linkChecked, setLinkChecked] = useState(false);

  // Pre-select entry when modal opens or preSelectedId changes
  useEffect(() => {
    if (open) {
      const match = masterEntries.find(
        (me) => me.CodeLegendMasterEntryId === preSelectedId
      );
      setSelectedEntry(match ?? null);
    }
  }, [open, preSelectedId, masterEntries]);

  const handleSelect = () => {
    if (selectedEntry) {
      onSelect(selectedEntry.CodeLegendMasterEntryId);
      if (linkChecked && typeof onLink === "function") {
        // Pass selectedEntry and its Description for Alt Description
        onLink({
          masterEntryId: selectedEntry.CodeLegendMasterEntryId,
          altDescription: selectedEntry.Description,
        });
      }
      setLinkChecked(false);
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        onClose();
        setSelectedEntry(null);
      }}
      maxWidth='sm'
      fullWidth>
      <DialogTitle>Select Standard Code Description</DialogTitle>
      <DialogContent>
        <br />
        <Autocomplete
          options={masterEntries}
          getOptionLabel={(option) => option.Description}
          getOptionKey={(option) => option.CodeLegendMasterEntryId}
          value={selectedEntry}
          onChange={(_, newValue) => setSelectedEntry(newValue)}
          renderInput={(params) => (
            <TextField
              {...params}
              label='Search by Description'
              fullWidth
              sx={{ mb: 2 }}
            />
          )}
          isOptionEqualToValue={(option, value) =>
            option.CodeLegendMasterEntryId === value.CodeLegendMasterEntryId
          }
          noOptionsText={<Typography>No master entries found.</Typography>}
        />
        <Tooltip title='Add this entry as an alternative description to the standard code description'>
          <FormControlLabel
            control={
              <Checkbox
                checked={linkChecked}
                onChange={(_, checked) => setLinkChecked(checked)}
              />
            }
            label='Link'
            sx={{ mt: 2 }}
          />
        </Tooltip>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleSelect}
          variant='contained'
          disabled={!selectedEntry}>
          Select
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MasterEntrySelectorModal;
